import { gql } from "@apollo/client";

// 绑定定价方案
export const BIND_PRICING_SCHEME = gql`
  mutation PricingSchemeApplyMutation($input: PricingSchemeApplyBindInput!) {
    bindPricingSchema(input: $input) {
      success
      message
      messageKey
    }
  }
`;

// 解绑定价方案
export const UNBIND_PRICING_SCHEME = gql`
  mutation PricingSchemeApplyMutation($input: PricingSchemeApplyUnBindInput!) {
    unbindPricingSchema(input: $input) {
      success
      message
      messageKey
    }
  }
`;

// 追加绑定（对已绑定的方案新增 bindValue）
export const APPEND_BIND_PRICING_SCHEME = gql`
  mutation PricingSchemeApplyMutation($input: PricingSchemeApplyAppendBindInput!) {
    appendBindPricingSchema(input: $input) {
      success
      message
      messageKey
    }
  }
`;

// 输入类型定义
export interface BindPricingSchemeInput {
  clientId: number;
  pricingSchemeId: number;
  bindValue: string[];
  effectiveNow?: boolean; // true: 立即生效, false: 未来生效
  effectiveDate?: string | null; // 格式: YYYY-MM-DD (未来生效时必填)
  timezone: string; // IANA 时区，如 "Asia/Shanghai", "America/Los_Angeles"
}

export interface UnbindPricingSchemeInput {
  clientId: number;
  pricingSchemeId: number;
  unBindValue: string[];
}

export interface AppendBindPricingSchemeInput {
  clientId: number;
  pricingSchemeId: number;
  bindValue: string[];
}

// 返回类型定义
export interface PricingSchemeApplyActionResult {
  success: boolean;
  message: string;
  messageKey?: string | null;
}

export interface BindPricingSchemeResponse {
  bindPricingSchema: PricingSchemeApplyActionResult;
}

export interface UnbindPricingSchemeResponse {
  unbindPricingSchema: PricingSchemeApplyActionResult;
}

export interface AppendBindPricingSchemeResponse {
  appendBindPricingSchema: PricingSchemeApplyActionResult;
}
